
import getPaymentProviders from '~/graphql/queries/getPaymentMethods.graphql';
import GwImageSingle from '~/patterns/atoms/image-single/image-single.vue';

export default {
    components: {
        GwImageSingle
    },
    data() {
        return {
            items: null
        };
    },

    async fetch() {
        const site = this.$config.appMultisiteHandle;
        const { data } = await this.$gql.executeQuery(getPaymentProviders, { site });

        if (data && data.paymentProviders.items) {
            this.items = data.paymentProviders.items;
        }
    }
};
